import { render, staticRenderFns } from "./ykReportPup.vue?vue&type=template&id=1ce878bf&scoped=true&"
import script from "./ykReportPup.vue?vue&type=script&lang=js&"
export * from "./ykReportPup.vue?vue&type=script&lang=js&"
import style0 from "./ykReportPup.vue?vue&type=style&index=0&id=1ce878bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce878bf",
  null
  
)

export default component.exports